import classNames from 'classnames';
import { isValidElement } from 'react';
import { Typography } from '../typography/typography';
import styles from './radio.module.scss';

interface RadioElemProps {
  name?: string;
  label?: React.ReactNode;
  isChecked?: boolean;
  value?: string;
  type?: 'white' | 'yellow' | 'ecommercePrimary';
  onChange?: (isChecked: boolean) => void;
  className?: string;
  dataCy?: string;
}
export const Radio = ({
  name,
  label,
  isChecked = false,
  value,
  type = 'yellow',
  onChange,
  className,
  dataCy = '',
}: React.PropsWithChildren<RadioElemProps>) => (
  <div
    className={classNames('flex justify-start items-center', styles.radio, className)}
    onClick={() => onChange && onChange(!isChecked)}
  >
    <input type="radio" name={name} checked={isChecked} value={value} onChange={() => {}} />
    <span
      className={classNames({
        [styles.white]: type === 'white',
        [styles.ecommerceRadioPrimary]: type === 'ecommercePrimary',
      })}
      data-cy={dataCy}
    ></span>
    {isValidElement(label) ? label : <Typography type="text-sm">{label}</Typography>}
  </div>
);
